import React, { Component } from 'react'
import './style.css'

class ArtWork extends Component {
  render () {
    return (
      <div className=''>
        <h1 className=''>ArtWork COMPONTENT</h1>
      </div>
    )
  }
}

export default ArtWork
